import * as React from 'react';
import { useState, useEffect, useRef, useCallback, useMemo } from 'react';
//import { Field } from '../../types/types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft, faChevronRight, faCloudDownloadAlt, faRedo } from '@fortawesome/free-solid-svg-icons';
import { Button } from 'react-bootstrap';
import { memo } from 'react';
import { useGetAllZones } from '../../../api/getAllZones';
import { useGetAllZonesPrelim } from '../../../api/getAllZonesPrelim';


type ZoneInfoDrawerProps = {
  zone: any;
  field: any;
  showClose?: boolean;
  showDownload?: boolean;
  onClose: () => void;
  children: React.ReactNode;
  side?: String | null;
  setShowDownload?: Function;
  setZones: Function;
  setZonesPrelim: Function;
  updateZonesets: number;
};

const ZoneInfoDrawer = ({
  zone,
  showClose=true,
  onClose,
  children,
  side="left",
  setShowDownload,
  showDownload,
  field, 
  setZones,
  setZonesPrelim,
  updateZonesets,
}: ZoneInfoDrawerProps) => {

  const { data: _zones, refetch: refetchZones  } = useGetAllZones(field); 
  const { data: _zonesPrelim, refetch: refetchZonesPrelim } = useGetAllZonesPrelim(field); 

  const [zonesGeoData, setZonesGeoData] = useState<any | null>(null);
  const [zonesGeoDataPrelim, setZonesGeoDataPrelim] = useState<any | null>(null);

  useEffect(() => {
    console.log("A040424 _zones", _zones);
    setZones(_zones);
    /*if (_zones && _zones.length > 0){
        setZonesGeoData(_zones[0].geojson.features.sort((a:any, b:any) => {
            if (a.properties.label < b.properties.label) {
            return -1;
            }
            if (a.properties.label > b.properties.label) {
            return 1;
            }
            return 0; // If 'a' and 'b' are equal
        }));
    }*/
}, [_zones]);

  useEffect(() => {
    console.log("A040424 _zonesPrelim", _zonesPrelim);
    setZonesPrelim(_zonesPrelim);
}, [_zonesPrelim]);

  useEffect(() => {
      console.log("A041124 updateZonesets", updateZonesets);
      refreshZonesPrelim();
  }, [updateZonesets]);

  const refreshZonesPrelim = () => {
    console.log("C060424 refreshZones");
    refetchZonesPrelim();
    refetchZones();
  }

  return (
    <div className="d-flex flex-column h-100">
      { (zone || showClose) &&
        <>
          <div className={`align-items-center d-flex justify-content-between pl-1 pr-2 pt-2 pb-0 ${side === "right" ? " abs-placement-chevron" : " "}`}>
            <h4 className="m-0 ml-2 text-lg font-weight-bold">{zone?.name}</h4>
              <div>
              { setShowDownload && showDownload &&
                <Button 
                  className="rounded-circle" variant="light" size="sm" title="Download map data" 
                  onClick={(e: any) => {
                    if (setShowDownload){
                      setShowDownload((prevState:boolean) => {
                        return !prevState;
                      });
                    }
                  }}
                  style={{cursor:'pointer', height:'30px', width:'30px', padding:'0.25rem 0.375rem'}}
                >
                  <FontAwesomeIcon icon={faCloudDownloadAlt} />
                </Button>
              }
              { showClose && 
                <Button className="rounded-circle" variant="light" size="sm" title="Close information bar" onClick={onClose} style={{cursor:'pointer', height:'30px', width:'30px'}}>
                  <FontAwesomeIcon icon={side === "left" ? faChevronLeft : faChevronRight} />
                </Button>
              }
            </div>
          </div>
          <div className="text-xs text-muted" style={{fontSize:'0.65rem', lineHeight:'0.75rem', paddingLeft:'10px'}}>{zone.name}</div>
        </>
      }
      <div className="flex-grow-1 pt-0 pb-2 px-2 pt-2 overflow-auto" style={{flexBasis: 0}}>
         {/*<Button className="rounded-circle" variant="light" size="sm" title="Close information bar" onClick={refreshZones} style={{cursor:'pointer', height:'30px', width:'30px'}}>
            <FontAwesomeIcon icon={faRedo} />
          </Button>*/}
        {children}
      </div>
    </div>
  );
};

export default memo(ZoneInfoDrawer);